import React from "react";
import { SmallIconButton } from "../SmallIconButton";
import { DishCard } from "../dish/DishCard";
import { NutriValues } from "../../data/nutriValues";

export function PlanCellCard({
  description,
  kcal,
  nutri,
  incomplete,
  expanded,
  personName,
  hasPencil,
  onToggleExpand,
  onEdit,
  onDelete,
  children,
}: {
  description: string;
  kcal: number;
  nutri?: NutriValues;
  incomplete: boolean;
  expanded: boolean;
  personName?: string;
  hasPencil: boolean;
  onToggleExpand: () => void;
  onEdit: () => void;
  onDelete: () => void;
  children: React.ReactNode;
}) {
  return (
    <DishCard
      dataCy="plan-cell-card"
      titleDataCy="plan-cell-card-title"
      title={description}
      personName={personName}
      kcal={kcal}
      nutri={nutri}
      borderClassName={incomplete ? "border-protein/70" : "border-line"}
      leading={
        incomplete ? (
          <span className="h-2 w-2 shrink-0 rounded-full bg-protein" />
        ) : undefined
      }
      expanded={expanded}
      onToggleExpand={onToggleExpand}
      actions={
        <>
          {hasPencil && (
            <SmallIconButton
              label="Gericht/Lebensmittel bearbeiten"
              data-cy="edit-pencil-button"
              icon="pencil"
              onClick={onEdit}
            />
          )}
          <SmallIconButton
            label="Entfernen"
            data-cy="plan-cell-delete-button"
            icon="delete"
            onClick={onDelete}
          />
        </>
      }
    >
      {children}
    </DishCard>
  );
}
